"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@sentry/browser");
var hub_1 = require("@sentry/hub");
var defaultOptions = {
    defaultIntegrations: [
        new browser_1.Integrations.InboundFilters(),
        new browser_1.Integrations.FunctionToString(),
        new browser_1.Integrations.TryCatch(),
        new browser_1.Integrations.Breadcrumbs({
            console: false,
        }),
        // new Integrations.GlobalHandlers(),
        new browser_1.Integrations.LinkedErrors(),
        new browser_1.Integrations.UserAgent(),
    ],
    sampleRate: 0.6,
};
var SentryHub = /** @class */ (function (_super) {
    __extends(SentryHub, _super);
    function SentryHub() {
        return _super.call(this) || this;
    }
    SentryHub.getInstance = function () {
        if (!this.instance) {
            this.instance = new SentryHub();
        }
        return this.instance;
    };
    SentryHub.prototype.setClient = function (options) {
        var client = new browser_1.BrowserClient(__assign(__assign({}, defaultOptions), options));
        this.bindClient(client);
        hub_1.makeMain(this); // the main line. (https://github.com/getsentry/sentry-javascript/issues/2356 https://github.com/getsentry/sentry-javascript/issues/2329)
    };
    return SentryHub;
}(browser_1.Hub));
exports.default = SentryHub.getInstance();
//# sourceMappingURL=sentryHub.js.map